import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BlIcon } from 'shared-react';
import { RawLinkButton } from 'consumer-components';

const styles = StyleSheet.create({
  backButton: {
    color: 'inherit',
    display: 'flex',
    font: 'inherit',
    fontSize: 'inherit',
    letterSpacing: 'inherit',
    lineHeight: 'inherit',
    pointerEvents: 'auto',
    cursor: 'pointer',
  },
  backArrow: {
    display: 'inline',
    paddingRight: 10,
    position: 'relative',
    top: '10%',
  },
});

function goBack(_e): void {
  history.go(-1);
}

interface ArrowBackButtonProps {
  onClick?: (_e: any) => void;
}

export default class ArrowBackButton extends React.Component<ArrowBackButtonProps> {
  render() {
    const { onClick } = this.props;
    // href hack for cross browser compatibility
    // http://simonthegeek.com/technical/history-back-problems-with-chrome-and-safari/
    return (
      <RawLinkButton type="button" data-it="ArrowBackButton" onClick={onClick || goBack}>
        <div className={css(styles.backButton)}>
          <div className={css(styles.backArrow)}>
            <BlIcon icon="date-arrow-left" />
          </div>
          Back
        </div>
      </RawLinkButton>
    );
  }
}
